import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/contexts/LanguageContext";
import { FAQItem, getText } from "./faqData";

interface FAQCategoryProps {
  category: string;
  faqs: FAQItem[];
}

export const FAQCategory = ({ category, faqs }: FAQCategoryProps) => {
  const { language } = useLanguage();

  return (
    <Accordion type="single" collapsible className="space-y-4">
      {faqs.map((faq, index) => (
        <AccordionItem
          key={index}
          value={`${category}-item-${index}`}
          className="bg-card border border-border rounded-xl px-6 shadow-sm hover:shadow-card transition-all duration-300"
        >
          <AccordionTrigger className="text-left hover:no-underline py-6 text-lg font-semibold text-foreground">
            {getText(faq.question, language)}
          </AccordionTrigger>
          <AccordionContent className="text-muted-foreground leading-relaxed pb-6 whitespace-pre-line">
            {getText(faq.answer, language)}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
